/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Compose_SubjectInputs */

const en_mail_compose_subject = /** @type {(inputs: Mail_Compose_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject`)
};

const de_mail_compose_subject = /** @type {(inputs: Mail_Compose_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betreff`)
};

/**
* | output |
* | --- |
* | "Subject" |
*
* @param {Mail_Compose_SubjectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_subject = /** @type {((inputs?: Mail_Compose_SubjectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_SubjectInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_subject(inputs)
	return en_mail_compose_subject(inputs)
});